import React from 'react';

const services = [
   {
      id: 1,
      icon: (
         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
            <rect x="6" y="2" width="12" height="20" rx="3" />
            <path d="M11 18h2" />
         </svg>
      ),
      title: 'Android App Development',
      desc: 'Building Android apps in Kotlin and Java. Most of my work is VPN and network tool apps, server scripts, server-side, connection management, protocol switching, and settings.',
      tags: ['Kotlin', 'Java', 'UI/UX'],
   },
   {
      id: 2,
      icon: (
         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
            <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z" />
            <path d="M9 12l2 2 4-4" />
         </svg>
      ),
      title: 'App Security',
      desc: 'Writing the security layer of Android apps in C++ via NDK. Focused on keeping apps protected when running on user devices.',
      tags: ['C++ NDK', 'App Security'],
   },
   {
      id: 3,
      icon: (
         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
            <circle cx="12" cy="12" r="3" />
            <path d="M3 12h2M19 12h2M12 3v2M12 19v2" />
            <path d="M5.6 5.6l1.4 1.4M16.9 16.9l1.4 1.4M5.6 18.4l1.4-1.4M16.9 7.1l1.4-1.4" />
         </svg>
      ),
      title: 'VPN Core & Protocol Integration',
      desc: 'Tunnel core in C, Go, and C++. I work with WireGuard, V2Ray, OpenVPN, SSH, DNSTT, and UDP protocols depending on the project requirements.',
      tags: ['C', 'Go', 'C++', 'WireGuard', 'V2Ray', 'OpenVPN'],
   },
   {
      id: 4,
      icon: (
         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
            <rect x="3" y="3" width="18" height="14" rx="2" />
            <path d="M7 21h10M12 17v4" />
            <path d="M7 8h.01M11 8h6" />
            <path d="M7 12h.01M11 12h6" />
         </svg>
      ),
      title: 'Server-side Security',
      desc: 'Server setup and security for VPN backends. Keeping the server side of VPN infrastructure secure and properly configured.',
      tags: ['Server Security', 'VPN Backend'],
   },
];

const ServicesSection = () => {
   return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
         {services.map((s) => (
            <div key={s.id} className="glass-card hover-card p-4 sm:p-5 group">
               <div className="flex items-center gap-3">
                  <div className="grid h-10 w-10 place-items-center rounded-xl bg-brand-500/10 text-brand-600 dark:text-brand-400 ring-1 ring-brand-500/20 transition-transform group-hover:scale-105">
                     {s.icon}
                  </div>
                  <h3 className="font-display text-[15px] font-bold tracking-tight">{s.title}</h3>
               </div>
               <p className="mt-3 text-[12.5px] leading-relaxed text-zinc-600 dark:text-zinc-400">{s.desc}</p>
               <div className="mt-3 flex flex-wrap gap-1.5">
                  {s.tags.map((t) => (
                     <span
                        key={t}
                        className="rounded-full bg-zinc-100 dark:bg-zinc-800/70 px-2 py-0.5 text-[10px] font-mono text-zinc-600 dark:text-zinc-300"
                     >
                        {t}
                     </span>
                  ))}
               </div>
            </div>
         ))}
      </div>
   );
};

export default ServicesSection;
